import Konva from "konva";
import { ProjectLoader } from "./SaveManager/ProjectLoader";
import store from "../../store/store";

const mouseEventsModule = require("./CreationEvents/MouseEvents");
const otherEventsModule = require("./CreationEvents/OtherEvent");

export class CreationController {
  constructor(stage, projectSize, projectName) {
    this.init = false;
    this.projectName = projectName;
    this.stage = stage;

    this.projectSize = { width: 0, height: 0 };

    if (projectSize !== undefined) {
      this.layerConfig = this.layerParameter();
      this.projectSize = projectSize;
    }

    this.scale = 1;
    this.mouseEvents = {};
    this.keyEvents = {};

    this.canObjectMove = true;
    this.startingMovePos = null;

    //This is used when the stage is moved by middleclick, do not use for something else, it can conflict
    this.repetitiveTask = false;
    this.elementPreventMovingLastPos = null;
    this.elementPreventMoving = null;

    this.layerList = {};

    this.currentLayer = null;
    this.currentLayerNumber = 0;
    this.currentTool = { name: "pointer", type: "basic" };

    this.currentOptionDisplayed = "";

    this.mainColor = "#FFFFFFFF";
    this.secondaryColor = "#000000FF";
    this.additionalProperties = null;
    this.shiftKeyPressed = false;
    this.altKeyPressed = false;
    this.ctrlKeyPressed = false;
    this.currentSelection = null;

    this.elements = {};
    this.currentElement = null;
    this.elementsNumber = 0;
    this.elementNameList = [];

    this.zoomCorrect = false;

    this.refreshAnimation = new Konva.Animation({});
    this.animations = [];
  }

  saveAnimations() {
    const animations = [];
    for (const key in this.elements) {
      const element = this.elements[key];
      if (element.animMvt) {
        animations.push({
          id: element.konvaObject.attrs.id,
          animation: element.saveAnimation(),
        });
      }
    }
    return animations;
  }

  loadAnimations(animationData) {
    if (!Array.isArray(animationData)) {
      return;
    }

    for (const anim of animationData) {
      const element = this.elements[anim.id];
      if (element) {
        element.loadAnimation(anim.animation);
      }
    }
  }

  addElementToCurrentLayer(elementToAdd) {
    this.cursor(elementToAdd);
    this.dblClick(elementToAdd);
    this.currentLayer.add(elementToAdd);
  }

  addElementToCurrentLayerReturn(elementToAdd) {
    this.cursor(elementToAdd);
    this.dblClick(elementToAdd);
    this.currentLayer.add(elementToAdd);
    return this.currentLayer;
  }

  addKeyEvent(keyButton, eventKey) {
    this.keyEvents[keyButton] = eventKey;
  }

  addMouseEvent(mouseButton, eventMouse) {
    this.mouseEvents[mouseButton] = eventMouse;
  }

  addNewElement(elementToAdd) {
    this.addNewLayer();
    this.addElementToCurrentLayer(elementToAdd);
  }

  addNewObjectToCurrentLayer(elementToAdd, elementName, tool) {
    let extra = "";
    switch (elementName) {
      case "Button":
        extra = " : " + tool.nameProject;
        break;
      case "Weather":
        extra = " : " + tool.dataWeather.city;
        break;
      case "Web":
        extra = " : " + tool.urlWeb;
        break;

      default:
        break;
    }

    const keyElement = elementName + " " + this.elementsNumber++ + extra;
    elementToAdd.setAttr("id", keyElement);
    this.elements[keyElement] = tool.createControllerObject(keyElement, elementToAdd);
    this.currentElement = this.elements[keyElement];
    return keyElement;
  }

  addNewLayer(layer = null) {
    const layerName = "Layer" + this.currentLayerNumber++;
    if (layer == null) {
      this.layerList[layerName] = new Konva.Layer(this.layerConfig);
    } else {
      this.layerList[layerName] = new Konva.Layer(layer);
    }
    this.currentLayer = this.layerList[layerName];
    this.stage.add(this.layerList[layerName]);
    this.layerList[layerName].moveDown();
    const refreshAnimation = new Konva.Animation(() => {}, this.currentLayer);
    refreshAnimation.start();
  }

  autoRescaleStage(containerSize) {
    otherEventsModule.centerAndRescaleEvent(this, containerSize);
  }

  cursor(elementToAdd) {
    const _this = this;
    let tempo = "";
    let noChange = false;

    elementToAdd.on("mouseenter", function () {
      tempo = _this.stage.container().style.cursor;
      if (tempo != "crosshair" && tempo != "pointer" && tempo != "move") {
        if (_this.currentElement !== null && elementToAdd.attrs !== undefined) {
          if (elementToAdd.attrs.id == _this.currentElement.name) {
            _this.stage.container().style.cursor = "grab";
          } else {
            _this.stage.container().style.cursor = "pointer";
          }
        } else {
          _this.stage.container().style.cursor = "pointer";
        }
        noChange = false;
      } else {
        noChange = true;
      }
    });
    elementToAdd.on("mousedown", function () {
      if (!noChange) {
        _this.stage.container().style.cursor = "grabbing";
      }
    });
  }

  cursorStage() {
    if (this.stage !== undefined) {
      const stage = this.stage;
      let actif = true;
      const currentTool = this.currentTool;
      this.stage.on("mousemove", function () {
        stage.on("mouseover", function () {
          let cursor = stage.container().style.cursor;
          if (actif) {
            if (currentTool.type !== "widget" && cursor != "move" && cursor != "crosshair" && cursor != "text") {
              stage.container().style.cursor = "default";
            }
            actif = false;
          }
        });
      });
      this.stage.on("mouseout", function () {
        actif = true;
      });
    }
  }

  createCompleteController(stage, projectSize, projectName) {
    this.stage = stage;

    this.projectName = projectName;
    this.layerConfig = this.layerParameter();
    this.projectSize = projectSize;

    this.addMouseEvent("zoom", mouseEventsModule.zoomWheelEvent);
    this.addMouseEvent("moveStage", mouseEventsModule.moveStage);
    this.addMouseEvent("moveStageEnd", mouseEventsModule.moveStageEnd);
    this.addMouseEvent("moveStageHoriz", mouseEventsModule.moveStageHorizontally);
    this.addMouseEvent("moveStageVertic", mouseEventsModule.moveStageVertically);
    this.addMouseEvent("displayTransformer", mouseEventsModule.displayTransformerOnClick);
    this.addNewLayer();

    const workSpaceDelimiter = new Konva.Rect(workSpaceRectangle(this.projectSize.width, this.projectSize.height));
    this.addElementToCurrentLayer(workSpaceDelimiter);
    this.currentLayer.moveToTop();
    workSpaceDelimiter.moveToTop();
    this.addNewLayer();
    this.init = true;
    this.cursorStage();
  }

  collectCurrentMousePosition() {
    return {
      x: this.stage.getPointerPosition().x - this.stage.x(),
      y: this.stage.getPointerPosition().y - this.stage.y(),
    };
  }

  createTransformer(elementToTransform) {
    return new Konva.Transformer({
      node: elementToTransform,
      keepRatio: false,
      enabledAnchors: [
        "top-left",
        "top-center",
        "top-right",
        "middle-right",
        "middle-left",
        "bottom-center",
        "bottom-left",
        "bottom-right",
      ],
    });
  }

  createTransformerOnCurrentElement() {
    this.currentSelection = this.createTransformer(this.currentElement.konvaObject);
    this.addElementToCurrentLayer(this.currentSelection);
  }

  deleteCurrentSelection() {
    if (this.currentSelection !== null) {
      if (this.currentSelection.nodes() !== null) {
        if (this.currentSelection.nodes().length > 0) {
          this.currentElement.delete();
          const id = this.getCurrentSelectionId();
          this.deleteElement(id);
          this.currentSelection.nodes()[0].destroy();
          this.destroyAllTransformer();
          this.currentOptionDisplayed = "";
          return id;
        }
      } else {
        return;
      }
    } else {
      return;
    }
  }

  dblClick(elementToAdd) {
    elementToAdd.on("dblclick dbltap", function () {
      // Check editable attrs to know if access to dialog on double click
      let isEditable = false;
      if (elementToAdd.attrs.editable !== undefined) {
        if (elementToAdd.attrs.editable) {
          isEditable = true;
        }
      } else {
        isEditable = true;
      }

      if (isEditable) {
        let name = elementToAdd.attrs.id;
        if (name !== undefined) {
          if (name.includes("Rect")) {
            store.dispatch("editOpen", "Rect").widget;
          } else if (name.includes("Text")) {
            store.dispatch("editOpen", "Text").widget;
          } else if (name.includes("Scrolling")) {
            store.dispatch("editOpen", "Scrolling").widget;
          } else if (name.includes("Image")) {
            store.dispatch("editOpen", "Image").widget;
          } else if (name.includes("pdf")) {
            store.dispatch("editOpen", "Pdf").widget;
          } else if (name.includes("Video")) {
            store.dispatch("editOpen", "Video").widget;
          } else if (name.includes("Web")) {
            store.dispatch("editOpen", "Web").widget;
          } else if (name.includes("rss")) {
            store.dispatch("editOpen", "Rss").widget;
          } else if (name.includes("Calendar")) {
            store.dispatch("editOpen", "Calendar").widget;
          } else if (name.includes("Button")) {
            store.dispatch("editOpen", "Button").widget;
          } else if (name.includes("Weather")) {
            store.dispatch("editOpen", "Weather").widget;
          }
        }
      }
    });
  }

  deleteElement(elementName) {
    delete this.elements[elementName];
  }

  deselectCurrentElement() {
    if (this.currentElement != null) {
      this.currentElement.deselect();
    }
    this.currentElement = null;
    this.currentOptionDisplayed = "";
  }

  destroyAll() {
    for (const key in this.elements) {
      this.elements[key].delete();
    }

    this.destroyAllTransformer();
  }

  destroyAllTransformer() {
    if (this.stage != null) this.stage.find("Transformer").destroy();
    this.currentSelection = null;

    try {
      if (this.stage != null) this.stage.draw();
    } catch (err) {
      console.error(err);
    }
  }

  disableDraggable() {
    this.canObjectMove = false;
  }

  enableDraggable() {
    this.canObjectMove = true;
  }

  extractPreviewStageConfig(idContainer, preview = false) {
    if (preview) {
      return {
        x: 0,
        y: 0,
        width: this.projectSize.width / 2.5,
        height: this.projectSize.height / 2.5,
        container: idContainer,
      };
    } else {
      return {
        x: 0,
        y: 0,
        width: this.projectSize.width,
        height: this.projectSize.height,
        container: idContainer,
      };
    }
  }

  getCurrentSelectionId() {
    if (this.currentSelection.nodes().length > 0) {
      return this.currentSelection.nodes()[0].attrs.id;
    } else {
      return;
    }
  }

  getCurrentSelectionOptionsFromId() {
    this.currentOptionDisplayed = this.currentElement.options();
  }

  getCurrentSelectionOptions(elementType) {
    this.currentOptionDisplayed = [];
    if (["Rect", "Image", "Video"].indexOf(elementType) != -1) {
      this.currentOptionDisplayed.push("Rect");
    }
    if (elementType == "Text") {
      this.currentOptionDisplayed.push("Text");
    }
    if (elementType == "Image") {
      this.currentOptionDisplayed.push("Image");
    }
    if (elementType == "Web") {
      this.currentOptionDisplayed.push("Web");
    }
    if (elementType == "Calendar") {
      this.currentOptionDisplayed.push("Calendar");
    }
    if (elementType == "Scrolling") {
      this.currentOptionDisplayed.push("Scrolling");
    }
    if (elementType == "rss") {
      this.currentOptionDisplayed.push("Scrolling");
    }
    if (elementType == "pdf") {
      this.currentOptionDisplayed.push("Scrolling");
    }
    if (elementType == "Weather") {
      this.currentOptionDisplayed.push("Weather");
    }
    return this.currentOptionDisplayed;
  }

  /**
   * Return the DMCVision object with the elementName given in argument
   * @param {The name of the konva element} elementName
   */
  getElementFromName(elementName) {
    return this.elements[elementName];
  }

  layerParameter() {
    return {
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
    };
  }

  load(savePath) {
    const load = JSON.parse(savePath);
    const projectLoader = new ProjectLoader();

    for (let element of Object.entries(load.elements)) {
      const loadedElement = projectLoader.createNewElement(element[1], this, false);
      this.elements[loadedElement.name] = loadedElement;
    }

    this.elementsNumber = load.elementsNumber;
    return Object.entries(load.elements);
  }

  mouseEventTrigger(mouseEventName, event) {
    this.mouseEvents[mouseEventName](this, event);
  }

  /**
   * This function render a new stage with the element present in this controller project.
   * @param {Konva.Stage} stage
   */
  renderPreview(stage, preview = false) {
    return new Promise((resolve, reject) => {
      if (stage == null) {
        return null;
      }

      this.refreshAnimation.stop();
      this.renderStage = stage;
      const layer = new Konva.Layer();
      this.renderStage.add(layer);

      const size = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      if (this.renderStage.scaleX() > 1) {
        this.renderStage.scale({ x: 1, y: 1 });
      }

      const tempo = [];
      for (let key in this.elements) {
        const element = this.elements[key].renderPreview(layer);
        element.object.index = element.zIndex;
        tempo.push(element.object);
      }

      tempo.sort(function (a, b) {
        return a.index - b.index;
      });

      tempo.forEach((element) => {
        layer.add(element);
      });

      this.refreshAnimation = new Konva.Animation(() => {}, layer);
      this.refreshAnimation.start();

      otherEventsModule.resizeStageForContainer(this.renderStage, size, null, this.zoomCorrect);

      if (preview) {
        const dialogW = window.innerWidth * 0.75;
        const dialogH = window.innerHeight * 0.75;

        const scaleW = dialogW / this.projectSize.width;
        const scaleH = dialogH / this.projectSize.height;

        let scale = scaleW;

        if (scaleH < scaleW) {
          scale = scaleH;
        }

        this.renderStage.scaleX(scale);
        this.renderStage.scaleY(scale);
      } else {
        this.renderStage.x(0);
        this.renderStage.y(0);
      }

      try {
        layer.draw();
      } catch (err) {
        console.error(err);
        return reject(err);
      }

      return resolve(this.renderStage);
    });
  }

  renderStart() {
    //
  }

  save(name) {
    this.projectName = name;
    return JSON.stringify(this, null, 2);
  }

  selectTool(tool) {
    this.deselectCurrentElement();
    this.destroyAllTransformer();
    this.currentTool = tool;

    if (tool.type == "basic") {
      return;
    }

    this.currentOptionDisplayed = this.getCurrentSelectionOptions(this.currentTool.name);
  }

  startPreview(objs = null) {
    objs = objs != null ? objs : this.elements;
    let totalDuration = 0;
    for (let key in objs) {
      objs[key].startPreview();
      //calcule la durée totale des animations bout à bout
      totalDuration += objs[key].animDelay ? parseFloat(objs[key].animDelay) + parseFloat(objs[key].animSpeed) : 0;
    }
    //lance les animations de sortie, après que toutes les animations d'entrées aient été jouées
    setTimeout(() => {
      for (let key in objs) {
        objs[key].startPreviewOut();
      }
    }, totalDuration * 1000);
  }

  stopPreview() {
    for (let key in this.elements) {
      this.elements[key].stopPreview();
    }
  }
}

function workSpaceRectangle(width, height, fill = "grey") {
  return {
    x: 0,
    y: 0,
    width: width,
    height: height,
    stroke: fill,
    strokeWidth: 5,
    listening: false,
  };
}
